import { combineReducers } from "redux";

import agencyReducer from "./agency/reducer";
import apiErrorReducer from "./apiError/reducer";
import campaignToCreateReducer from "./campaignToCreate/reducer";
import sessionReducer from "./session";
import userReducer from "./user";
import { RESET_APP_STATE } from "./reset";
import { ReduxApplicationState } from "../../types/ReduxTypes/ReduxApplicationState";

const appReducer = combineReducers<ReduxApplicationState>({
  agency: agencyReducer,
  campaignToCreate: campaignToCreateReducer,
  session: sessionReducer,
  user: userReducer,
  apiError: apiErrorReducer,
});

const rootReducer = (state: ReturnType<typeof appReducer> | undefined, action: any) => {
  if (action.type === RESET_APP_STATE) {
    /* eslint-disable no-param-reassign */
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
